import React from 'react';
import NumberFormat from 'react-number-format';

interface Props {
  value: number | string | null;
}

const FormatCurrency = (props: Props): JSX.Element => {
  return (
    <NumberFormat
      value={props.value}
      displayType={'text'}
      thousandSeparator={true}
      fixedDecimalScale={true}
      decimalScale={2}
      prefix={'$'}
    />
  );
};

export default FormatCurrency;
